import { cn } from "@/lib/utils";
import { useTheme } from "next-themes";
import { AIAssistantHeader } from "./AIAssistantHeader";
import { AIAssistantToolbar } from "./AIAssistantToolbar";
import { TokenWarningBanner } from "@/components/tokens/TokenWarningBanner";
import { TokenStats } from "@/types/tokens";

interface ChatLayoutProps {
  children: React.ReactNode;
  isLoading: boolean;
  isAnalyzing: boolean;
  tokenStats?: TokenStats;
  onFileUpload: (file: File) => Promise<void>;
  onPurchase: () => void;
}

export function ChatLayout({
  children,
  isLoading,
  isAnalyzing,
  tokenStats,
  onFileUpload,
  onPurchase
}: ChatLayoutProps) {
  const { theme } = useTheme();

  return (
    <div 
      className={cn(
        "flex-1 flex flex-col h-[calc(100dvh-4rem)] overflow-hidden transition-colors duration-300",
        theme === 'dark' ? 'bg-background dark' : 'bg-background light',
        "motion-safe:animate-fade-in"
      )}
      data-theme={theme}
    >
      <div className="flex-1 flex flex-col min-h-0 relative">
        <header className="border-b p-2 md:p-4 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 sticky top-0 z-50">
          <AIAssistantHeader isLoading={isLoading} />
          <AIAssistantToolbar 
            isAnalyzing={isAnalyzing}
            onFileUpload={onFileUpload}
          />
        </header>

        {tokenStats && (
          <TokenWarningBanner 
            usagePercentage={tokenStats.usagePercentage}
            onPurchase={onPurchase}
          />
        )}

        {children}
      </div>
    </div>
  );
}